import React from 'react';
import { IconProps } from '.';
import Svg from '../Svg';
const SvgIconLongArrowRightRegular32 = ({ size = 32, color, ...props }: IconProps): JSX.Element => {
  return (
    <Svg width={size} height={size} fill='none' viewBox='0 0 32 32' color={color} {...props}>
      <path stroke='currentColor' strokeWidth={1.5} d='m17.2 9 7 7-7 7' />
      <path stroke='currentColor' strokeLinejoin='round' strokeWidth={1.5} d='M24 16H7' />
    </Svg>
  );
};
export default SvgIconLongArrowRightRegular32;
